var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1EA7F7D7-60EA-4D5C-A0D4-8E2DBEA97888@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEA7-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mais-web-4-blad",
    transform: "translate(-141.000000, -561.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(120.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox/Selected-Copy-2",
    transform: "translate(21.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    fill: "#F2DEDE",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,4 C9.6209139,4 9.8,4.1790861 9.8,4.4 L9.8,8.199 L13.6,8.2 C13.8209139,8.2 14,8.3790861 14,8.6 L14,9.4 C14,9.6209139 13.8209139,9.8 13.6,9.8 L9.8,9.799 L9.8,13.6 C9.8,13.8209139 9.6209139,14 9.4,14 L8.6,14 C8.3790861,14 8.2,13.8209139 8.2,13.6 L8.2,9.799 L4.4,9.8 C4.1790861,9.8 4,9.6209139 4,9.4 L4,8.6 C4,8.3790861 4.1790861,8.2 4.4,8.2 L8.2,8.199 L8.2,4.4 C8.2,4.1790861 8.3790861,4 8.6,4 L9.4,4 Z",
    id: "Combined-Shape",
    fill: "#BC514E",
    transform: "translate(9.000000, 9.000000) rotate(-45.000000) translate(-9.000000, -9.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCheck);
export default __webpack_public_path__ + "static/media/error-check.b7c3b5a15a65056430e0fd0be0279d91.svg";
export { ForwardRef as ReactComponent };